/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Contact_Representative_ValueInputs */

const es_privacy_policy_contact_representative_value = /** @type {(inputs: Privacy_Policy_Contact_Representative_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matias Merkier`)
};

const en_privacy_policy_contact_representative_value = /** @type {(inputs: Privacy_Policy_Contact_Representative_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matias Merkier`)
};

/**
* | output |
* | --- |
* | "Matias Merkier" |
*
* @param {Privacy_Policy_Contact_Representative_ValueInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_contact_representative_value = /** @type {((inputs?: Privacy_Policy_Contact_Representative_ValueInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Contact_Representative_ValueInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_contact_representative_value(inputs)
	return en_privacy_policy_contact_representative_value(inputs)
});
export { privacy_policy_contact_representative_value as "privacy_policy.contact.representative_value" }